import React from 'react';

interface FieldSpacerProps extends React.HTMLAttributes<HTMLDivElement> {}

export const FieldSpacer = (props: FieldSpacerProps) => <div className="pb-7" {...props} />;
